
import React, { useState, useRef, useEffect } from 'react';

export const Info_pckg = ({
}) => {
      const [holder, setHolder] = useState(false);
      return (
      <>
      <h5>Ownership</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
        For collectors (and even gamblers), holding a <i>TODEM</i> Tile represents a commitment to contemporary art in a digitally-native form.  
        Jason Salavon Studio has made computational fine art, in public, for decades and as its first blockchain-based artwork, <i>TODEM</i> presents a 
        chance for a larger audience to participate in the studio's ongoing project of fusing technological innovation 
        with conceptually-driven artistic expression. 
        <br></br>
        <br></br>
        In addition to owning the Tile's token, holders are entitled to a suite of benefits specificed below.  
        Tiles inherit the benefits of the class below such that class C holders receive class C & D benefits, 
        class B receive B, C & D, etc.
        <br></br>
        <br></br>
        All Tile holders will receive early, discounted access to our next offering.
        <br></br>
        <br></br>
        <h5>Benefits</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
        <h6>Class D (0500-0999):</h6>
        With Class D Tiles, you will receive a digital "Collector Package". This includes three MP4 versions of your Tile (small, medium, and native sizes), a JPEG thumbnail, and a metadata file for v14, v42, and v56 of <i>TODEM</i> (in total: 9 MP4s, 3 JPEGs, and 1 metadata file). You’ll also be given free tokens, or TPX, in proportion to the number of pixels in your Tile. Download your Collector Package from the popout window for your Tile, and claim your TPX on the 
        <a
        href="https://www.latentculture.com/todem/info.TPX"
        rel="noreferrer"
        target="_blank"
      >
        {' '}TPX 
      </a> page of the website. 
        <br></br>
        <br></br>
        <h6>Class C (0100-0499):</h6>
        For Class C Tiles, you will receive all the Class D benefits including a Collector Package for your Tile. You will also get double the TPX, or two times the number TPX in proportion to the number of pixels in your Tile. 
        <br></br>
        <br></br>
        <h6>Class B (0010-0099):</h6>
        With Class B, your <i>TODEM</i> experience enters the physical world. Along with the Collector Package, you'll receive a unique ~24" x 24" native resolution print of your Tile's thumbnail, signed by Jason Salavon. On top of that, you’ll receive three times the number of TPX in proportion to the number of pixels in your Tile. 
        <br></br>
        <br></br>
        <h6>Class A (0000-0009):</h6>
        Class A Tiles represent the peak <i>TODEM</i> experience. In addition to all Class B, C, and D benefits, owners receive a bespoke large-screen monitor and playback system configured for your Tile. This setup enables you to display your Tile as a unique video artwork. You also get real bang for your buck, receiving four times as many TPX in proportion to the number of pixels in your Tile.
        <br></br>
        <br></br>
      </>
  );
}

export default Info_pckg;